import '../../utils/index.mjs';
import _sfc_main from './src/page-header2.mjs';
export { pageHeaderEmits, pageHeaderProps } from './src/page-header.mjs';
import { withInstall } from '../../utils/vue/install.mjs';

const ElPageHeader = withInstall(_sfc_main);

export { ElPageHeader, ElPageHeader as default };
//# sourceMappingURL=index.mjs.map
